import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import AddressModel from "../../models/address";

export default class AddressRepository extends BaseRepository {
  static modelClass = AddressModel;
  modelName = "address";
}
